import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CameraSquareIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsx("path", {
                            d: "M23.095 1.415c-.49-.49-1.14-.76-1.83-.76H3.745c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v17.51c0 .68.28 1.35.76 1.83.49.49 1.14.76 1.83.76h17.51c.69 0 1.34-.27 1.83-.76.48-.48.76-1.15.76-1.83V3.245c0-.69-.27-1.34-.76-1.83h.01zm-1.24 19.35c0 .16-.06.31-.17.42a.59.59 0 01-.42.17H3.745a.59.59 0 01-.42-.17.59.59 0 01-.17-.42V3.245c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h17.51c.16 0 .31.06.42.17.11.11.17.26.17.42v17.51l.01.01z"
                        }),
                        _jsx("path", {
                            d: "M16.485 7.815h-.26l-1.29-1.94c-.19-.28-.5-.45-.83-.45h-3.18c-.33 0-.65.17-.83.45l-1.3 1.94h-.26c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v3.98c0 .69.27 1.34.76 1.83s1.14.76 1.83.76h7.96c.69 0 1.34-.27 1.83-.76s.76-1.14.76-1.83v-3.98c0-.69-.27-1.34-.76-1.83s-1.14-.76-1.83-.76h-.01zm.59 6.57c0 .16-.06.31-.17.42a.59.59 0 01-.42.17h-7.96a.59.59 0 01-.42-.17.59.59 0 01-.17-.42v-3.98c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h.8c.33 0 .65-.17.83-.45l1.3-1.94h2.11l1.29 1.94c.19.28.5.45.83.45h.8c.16 0 .31.06.42.17.11.11.17.26.17.42v3.98z"
                        }),
                        _jsx("path", {
                            d: "M12.505 10.405c-.21 0-.42.04-.61.12-.19.08-.36.2-.52.35-.15.15-.26.32-.34.52a1.617 1.617 0 000 1.22c.08.19.2.37.34.51s.32.27.51.34a1.588 1.588 0 001.74-.35c.3-.3.47-.71.47-1.13a1.606 1.606 0 00-1.6-1.6l.01.02z"
                        })
                    ]
                })
            })
        ]
    });
};
CameraSquareIcon.isCarinaIcon = true;
export default CameraSquareIcon;
